import {Component, OnInit} from '@angular/core';
import {EnvironmentService} from '../../../../../core/services/environment.service';

@Component({
  selector: 'unknown-has-retried',
  templateUrl: './unknown-has-retried.component.html'
})
export class UnknownHasRetriedComponent implements OnInit {

  constructor(private environmentService: EnvironmentService) {
  }

  ngOnInit(): void {
  }

  onWorkshopSearch(): void {
    document.location.href = this.environmentService.workshopSearchEndpoint;
  }
}
